import React from 'react';

export const Button = ({ children, ...props }: any) => (
  <button
    {...props}
    className="text-lg px-8 py-4 rounded-full bg-white text-black hover:bg-gray-300 transition"
  >
    {children}
  </button>
);